import Utils from "./utils";

export default class RazorPayUtils {
    static get KEY_ID() { return Utils.RAZORPAY_KEY_ID; }
    static PROVIDER = "razorpay"

    static get MANOSHANTI_API_KEY() { return Utils.RAZORPAY_KEY_ID_MANOSHANTI; }

    static get STHIRA_API_KEY() { return Utils.RAZORPAY_KEY_ID_STHIRA; }

    static PAYMENT_CONFIGS: {
        [heId: string]: { apiKey: string; bussinessName: string; description: string }
    } = {
            "82c396f751084cbbbc1d13ccc789f100": {  // Hubli
                get apiKey() { return Utils.RAZORPAY_KEY_ID_MANOSHANTI; },
                bussinessName: "GNR MANOSHANTI",
                description: "GNR MANOSHANTI"
            },
            "f5c0d62cf3a64f9da22d503d46693a9b": {  // Pune
                get apiKey() { return Utils.RAZORPAY_KEY_ID_MANOSHANTI; },
                bussinessName: "GNR MANOSHANTI",
                description: "GNR MANOSHANTI"
            },
            "578d457c4e4845349f3c7bc5b9b716f2": {  // Bengaluru
                get apiKey() { return Utils.RAZORPAY_KEY_ID_MANOSHANTI; },
                bussinessName: "GNR MANOSHANTI",
                description: "GNR MANOSHANTI"
            },
            "85a27dd5f48e4d758348cb6eaae09539": {  // Dharwad
                get apiKey() { return Utils.RAZORPAY_KEY_ID_MANOSHANTI; },
                bussinessName: "GNR MANOSHANTI",
                description: "GNR MANOSHANTI"
            },
            "9d0c34043d304c4398c2485160dff1d2": {  // Mysuru
                get apiKey() { return Utils.RAZORPAY_KEY_ID_MANOSHANTI; },
                bussinessName: "GNR MANOSHANTI",
                description: "GNR MANOSHANTI"
            },
            "0bfcdc4384664b5f990e00f59eca8199": { // STHIRA Test mode
                get apiKey() { return Utils.RAZORPAY_KEY_ID_STHIRA; },
                bussinessName: "STHIRA MENTAL HEALTH SOLUTIONS LLP",
                description: "STHIRA MENTAL HEALTH SOLUTIONS LLP"
            },
            "fcd97d6b312e47b29465ba031ad10bb2": {  // MANOLLASA Suhas
                get apiKey() { return Utils.RAZORPAY_KEY_ID_MANOSHANTI; },
                bussinessName: "Summit Solutions",
                description: "Summit Solutions"
            }
        }

}
